import React from 'react';
import { RELATION_COLORS, RELATION_DASH } from './familyTreeData';

const ENTRIES = [
  { type: 'parent',  label: 'Parent / Child',        dash: null      },
  { type: 'spouse',  label: 'Spouse / Partner',       dash: '6 3'     },
  { type: 'sibling', label: 'Sibling',                dash: '4 4'     },
  { type: 'cousin',  label: 'Cousin',                 dash: '8 4 2 4' },
];

const FamilyTreeLegend = () => (
  <div className="flex flex-wrap items-start gap-x-8 gap-y-4">
    {/* Edge types */}
    <div>
      <p className="text-[8px] font-black uppercase tracking-widest text-text-muted mb-2">Relationships</p>
      <div className="flex flex-wrap gap-x-6 gap-y-2">
        {ENTRIES.map(e => (
          <div key={e.type} className="flex items-center gap-2">
            <svg width={32} height={12}>
              <line
                x1={2} y1={6} x2={30} y2={6}
                stroke={RELATION_COLORS[e.type]}
                strokeWidth={2}
                strokeDasharray={e.dash ?? undefined}
                strokeLinecap="round"
              />
            </svg>
            <span className="text-[9px] font-black uppercase tracking-widest text-text-muted">
              {e.label}
            </span>
          </div>
        ))}
      </div>
    </div>

    {/* Node types */}
    <div>
      <p className="text-[8px] font-black uppercase tracking-widest text-text-muted mb-2">Nodes</p>
      <div className="flex flex-wrap gap-x-6 gap-y-2">
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 rounded-full bg-accent-navy border-2 border-accent-gold" />
          <span className="text-[9px] font-black uppercase tracking-widest text-text-muted">Deceased</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 rounded-full bg-brand-light border-2 border-brand-dark" />
          <span className="text-[9px] font-black uppercase tracking-widest text-text-muted">Living</span>
        </div>
        <div className="flex items-center gap-2 relative">
          <div className="relative w-4 h-4">
            <div className="w-4 h-4 rounded-full bg-pink-50 border-2"
              style={{ borderColor: RELATION_COLORS.cousin, borderStyle: 'dashed' }} />
            <div className="absolute -top-1 -right-1 w-3 h-3 rounded-full flex items-center justify-center"
              style={{ background: RELATION_COLORS.cousin }}>
              <span className="text-white text-[6px] font-black">C</span>
            </div>
          </div>
          <span className="text-[9px] font-black uppercase tracking-widest text-text-muted">Cousin</span>
        </div>
      </div>
    </div>
  </div>
);

export default FamilyTreeLegend;